import axios from "axios";
const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

export const invalidAccessLogout = async () => {
  const refreshToken = sessionStorage.getItem("refreshToken");

  try {
    if (refreshToken) {
      await axios.post(`${REACT_APP_BACKEND_ROUTE_URL}logout/`, {
        refresh_token: refreshToken,
      });
    }
  } catch (error) {
    console.error("Error while logging out:", error);
  } finally {
    sessionStorage.clear();
    window.location.href = "/login"; // using window.location as it's not a React component
  }
};
